import React from 'react';
import './ApiLoaderOverlay.css';

/**
 * Full-screen overlay loader matching the chat navigation loader:
 * blurry white background, orange circle with arrow, optional text.
 * Use when calling APIs (e.g. Company Settings, Profile Settings).
 */
function ApiLoaderOverlay({ text = 'Loading...', subtext = '', isInternal }) {

  return (
    <div className="kj-loader-overlay kj-loader-overlay--blur">
      <div className="kj-loader-card">
        <div className="kj-loader-icon">
          <div className={`kj-loader-pulse api-loader-overlay__pulse${isInternal ? ' api-loader-overlay__pulse--internal' : ''}`} />
          <div
            className={`kj-loader-circle api-loader-overlay__circle${isInternal ? ' api-loader-overlay__circle--internal' : ''}`}
          >
            <svg className="kj-loader-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>
        <div className="kj-loader-text">
          {text}
          {subtext && <div className="kj-loader-subtext">{subtext}</div>}
        </div>
      </div>
    </div>
  );
}

export default ApiLoaderOverlay;
